import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook, Twitter } from "lucide-react";
import Logo from "./Logo";

// Internal-route links (react-router)
const vendorLinks = [
  { label: "Join as Vendor", to: "/vendor-registration" },
  { label: "Vendor Sign In", to: "/vendor-signin" },
  { label: "Vendor Dashboard", to: "/dashboard" },
];

const companyLinks = [
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
];

// On-page section anchors (live on the home page)
const productLinks = [
  { label: "Features", href: "/#features" },
  { label: "For Vendors", href: "/#vendors" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "AI Planner", href: "/#ai-planner" },
];

const socials = [
  { Icon: Instagram, href: "https://instagram.com/mandapai", label: "Instagram" },
  { Icon: Facebook, href: "https://facebook.com/mandapai", label: "Facebook" },
  { Icon: Twitter, href: "https://twitter.com/mandapai", label: "Twitter" },
  { Icon: Mail, href: "mailto:support@mandapai.in", label: "Email" },
];

const linkClass =
  "text-gray-400 hover:text-white transition-colors duration-200 text-sm";

const SiteFooter = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Logo theme="dark" size={34} tagline className="mb-4" />
            <p className="text-gray-400 text-sm leading-relaxed mb-5 max-w-xs">
              India's event marketplace connecting trusted vendors with customers
              nationwide.
            </p>
            <div className="flex items-center gap-3">
              {socials.map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center text-gray-400 hover:text-white transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">Product</h4>
            <ul className="space-y-3">
              {productLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className={linkClass}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* For Vendors */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">For Vendors</h4>
            <ul className="space-y-3">
              {vendorLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className={linkClass}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className={linkClass}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} MandapAI. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className={linkClass}>Privacy</Link>
            <Link to="/terms" className={linkClass}>Terms</Link>
            <Link to="/contact" className={linkClass}>Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
